module.exports = {
  content: ['./src/client/components/**/*.{js,ts,jsx,tsx}', './src/pages/**/*.{js,ts,jsx,tsx}'],
  theme: {
    colors: {
      white: '#ffffff',
      'light-black': '#4D5253',
      brown: '#e99210',
      yellow: '#fac100',
      'pale-yellow': '#fff171',
      'light-yellow': '#FFF6DA',
      pink: '#ff6a61',
      green: '#48afaa',
      'pale-green': '#F1F9F9',
      'light-green': '#E6F0F0',
      'light-green2': '#76CCCB',
      'light-green3': '#91CFCC',
      'dark-green': '#E6F4F4',
      'dark-green2': '#00979E',
      'light-blue': '#E6EEF4',
      'review-hints': '#F3FAFA',
      black: '#333333',
      red: '#ff7272',
      'light-red': '#ff8b84', //snackbar
      'light-red2': '#FFBE9D',
      'light-pink': '#FFEFEE',
      'light-pink2': '#fbe8e7',
      gray: '#dddddd',
      gray2: '#dadada',
      gray3: '#D8D8D8',
      gray4: '#E5E5E5',
      gray5: '#EDEDED',
      'light-gray': '#ededed',
      'light-gray2': '#C0CCCE',
      'light-gray3': '#6E7374',
      'light-gray4': '#99A2A4',
      'light-gray5': '#b1c6c7',
      'pale-gray': '#f6f6f6',
      'pale-gray2': '#f8f8f9',
      'dark-gray': '#555555',
      'deep-gray': '#777777',
      'off-white': '#F8F8F9',
      'bank-gray': '#b4b4b4',
      'id-gray': '#9b9b9b',
      'care-gray': '#757575',
      'font-gray': '#8F8F8F',
    },

    extend: {
      spacing: {
        '1/2-negative': '-50%',
      },
      margin: {
        7: '1.75rem',
      },
      padding: {
        7: '1.75rem',
      },
      borderRadius: {
        button: '34px',
      },
      outline: {
        DEFAULT: '5px auto -webkit-focus-ring-color',
        red: '2px auto #ff7272',
      },
      height: {
        button: '50px',
      },
      minHeight: {
        'request-verification-form': '450px',
      },
      inset: {
        4: '1rem',
      },
      gridTemplateColumns: {
        'text-with-icon': 'max-content 1fr',
        'remain-preparation-to-apply-link': 'max-content 1fr max-content',
        'review-from-facility-rating': '1fr 120px',
        'penalty-point-history-table': '90px 1fr 80px',
      },
      gridTemplateRows: {
        '1fr-maxContent': '1fr max-content',
      },
      zIndex: {
        modal: 50,
      },
    },
  },
};
